import {Component, OnInit, ViewChild} from '@angular/core';
import {CodaltComponent} from '../codalt/codalt.component';
import {ExportInterfaceService} from '../../services/export-interface.service';
import {Entity} from '../../classes/entity';
import {Utils} from '../../utils.class';
import * as turf from '@turf/turf';
import {GoogleMap} from '@angular/google-maps';
import {Position} from '@turf/helpers';
import MapTypeId = google.maps.MapTypeId;
import LatLng = google.maps.LatLng;

@Component({
    selector: 'app-export-interface',
    templateUrl: './export-interface.component.html',
    styleUrls: ['./export-interface.component.scss']
})
export class ExportInterfaceComponent extends CodaltComponent implements OnInit {
    entities: Entity[];
    activeEntity: Entity;
    selectedEntities: Entity[] = [];
    @ViewChild('googleMap') googleMap: GoogleMap;
    options: google.maps.MapOptions = {
        mapId: '55a928ad53a65407',
        center: {lat: 52.5, lng: 5},
        zoom: 12,
        tilt: 0,
        headingInteractionEnabled: false,
        isFractionalZoomEnabled: false,
        fullscreenControl: false,
        disableDefaultUI: true,
        mapTypeControl: false,
        zoomControl: false,
        streetViewControl: false,
        restriction: Utils.RestrictToNl()
    };
    center: { lat: number; lng: number };
    mapTypeId = 'roadmap' as MapTypeId;
    setZoom: number;
    filteredEntities: Entity[];
    line: LatLng[];
    extras: { lat: number; lng: number; }[];
    basicpoints: { lat: number; lng: number; }[];

    constructor(private exportInterfaceService: ExportInterfaceService) {
        super();
    }

    ngOnInit() {
        this.subscriptions.add(this.exportInterfaceService.get().subscribe(data => {
            this.entities = data.data;
        }));
    }

    active(entity: Entity) {
        this.activeEntity = entity;
        this.filteredEntities = [entity];
        const itemBbox = entity.bbox ?? entity.line ?? entity.gnd;
        const coordinates = [];
        coordinates.push(turf.point(itemBbox.coordinates[0] as any));
        coordinates.push(turf.point(itemBbox.coordinates[1] as any));
        const bbox = turf.buffer(turf.bboxPolygon(turf.bbox(turf.featureCollection(coordinates))), 15, {units: 'meters'});
        const [minLng, minLat, maxLng, maxLat] = turf.bbox(bbox);
        const bounds = new google.maps.LatLngBounds(
            new google.maps.LatLng(minLat, minLng),
            new google.maps.LatLng(maxLat, maxLng)
        );
        this.googleMap.fitBounds(bounds, 100);

        function closestBearing(a, b, ref) {
            const diff = (x, y) => Math.min((x - y + 360) % 360, (y - x + 360) % 360);
            return diff(a, ref) < diff(b, ref) ? a : b;
        }

        // rotation
        const bearing = turf.bearing(entity.gnd.coordinates[0] as Position, entity.gnd.coordinates[1] as Position);

        const optionOne = (360 + bearing - 90) % 360;
        const optionTwo = (360 + bearing + 90) % 360;
        const useOption = closestBearing(optionOne, optionTwo, entity.rotation);
        console.log({optionOne, optionTwo, rot: entity.rotation, useOption});

        const start = turf.point(entity.gnd.coordinates[0] as Position);
        const end = turf.destination(start, 25, useOption, {units: 'meters'});
        const newend = turf.destination(start, 30, entity.rotation, {units: 'meters'});


        const lineStartAndEnd = turf.featureCollection([turf.point(entity.line.coordinates[0]), turf.point(entity.line.coordinates[entity.line.coordinates.length - 1])]);
        const endLine = turf.nearestPoint(
            turf.point(entity.gnd.coordinates[0] as Position),
            lineStartAndEnd
        );
        const startLine = JSON.stringify(lineStartAndEnd.features[0].geometry) == JSON.stringify(endLine.geometry) ? lineStartAndEnd.features[1].geometry : lineStartAndEnd.features[0].geometry;

        this.exportInterfaceService.getSiblings(entity.id).subscribe(data => {
            this.filteredEntities = data.data;
            this.selectedEntities = [...this.filteredEntities];
            this.extras = [];
            this.calculatRoute();
        });
    }

    selectEntity = (entity: Entity) => {
        this.extras = [];
        if (this.selectedEntities.indexOf(entity) !== -1) {
            this.selectedEntities.splice(this.selectedEntities.indexOf(entity), 1);
        } else {
            this.selectedEntities.push(entity);
        }

        this.calculatRoute();
    }

    calculatRoute() {
        let input = [...this.selectedEntities.map(fe => {
            return {lat: fe.gnd.coordinates[0][1], lng: fe.gnd.coordinates[0][0]};
        })];
        this.basicpoints = [...input];
        if (this.extras?.length > 0) {
            input.splice(1, 0, ...this.extras ?? []);
        }
        this.subscriptions.add(this.exportInterfaceService.snapToRoad(input).subscribe(rsult => {
            setTimeout(() => {
                this.line = rsult['snappedPoints'].map(sp => {
                    return {
                        'lat': sp['location']['latitude'],
                        'lng': sp['location']['longitude']
                    }
                })
            });
        }));
    }

    removeExtra(event, index) {
        this.extras.splice(index, 1);
        this.extras = [...this.extras];
        this.calculatRoute();
    }

    changeSelectionExtra(event, index) {
        this.extras[index] = {lat: event?.latLng?.lat(), lng: event?.latLng?.lng()};
        this.extras = [...this.extras];
        this.calculatRoute();
    }

    addPointToExtra(event) {
        this.extras = [...this.extras ?? [], {lat: event?.latLng?.lat(), lng: event?.latLng?.lng()}];
        this.calculatRoute();
    }

    toggleMapType() {
        const usedTypes = [
            google.maps.MapTypeId.ROADMAP,
            'BGT',
            google.maps.MapTypeId.HYBRID,
            'OSM'
        ];
        this.mapTypeId = usedTypes[usedTypes.indexOf(this.mapTypeId) + 1] ?? usedTypes[0] as any;
    }
}
